import type { UnitConfiguration } from '@/typings/unitConfigurations/UnitConfiguration';
import { useLocale } from './useLocale';

export function useUnitConfigurationsApi() {
  const baseUrl = '/umbraco/api/unitconfigurations';
  const { getLocale } = useLocale();

  async function getAllUnitConfigurations(): Promise<UnitConfiguration[]> {
    const lang = getLocale();

    const url = `${baseUrl}?locale=${lang}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch unit configurations: ${response.statusText}`);
    }

    return await response.json();
  }

  async function getUnitConfiguration(id: number): Promise<UnitConfiguration> {
    const lang = getLocale();

    const url = `${baseUrl}/${id}?locale=${lang}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch unit configuration: ${response.statusText}`);
    }

    return await response.json();
  }

  return {
    getAllUnitConfigurations,
    getUnitConfiguration,
  };
}